const serializedBrand = process.env.VUE_APP_BRAND_CONFIG

if (!serializedBrand) {
  throw new Error('Missing VUE_APP_BRAND_CONFIG. Restart the dev server with npm run serve:lpt or npm run serve:mt.')
}

const brand = JSON.parse(serializedBrand)

export default Object.freeze(brand)

export function brandPrefix() {
  return brand.invoice && brand.invoice.numberPrefix
    ? brand.invoice.numberPrefix
    : (brand.id || 'lpt').toUpperCase()
}

export function brandCode() {
  return (brand.id || 'lpt').toUpperCase()
}
